/*
  Serviceleistungen aus den Versandtarifen (Entwurf 25.10.2026).

  Quelle: assets/cx-shipping-rates.json – Abzug der Versandprofile aus dem Admin (Profil → Produkte, Zonen → Länder,
  Versandarten mit Preis und Warenwert-Bedingungen). Daraus wird je Produkt, Land und Preis berechnet, was in der
  Lieferung drin ist (Wohnung? Aufbau?) und was Montage / Altmöbelmitnahme zusätzlich kosten – exakt die Differenz
  der Versandarten, die der Kunde an der Kasse wählen kann. Preise in Shop-Währung (EUR); andere Währungen rechnet
  die Kasse um.

  API: window.LB24Services.load().then(function (db) { var r = LB24Services.compute(db, productId, priceEur, 'DE'); })
  r = null                        → Land wird für dieses Produkt nicht beliefert / kein Profil
  r = { base: {label, sub, included:['wohnung','montage']}, options: [{key:'montage', label, price, method}], combo: {price, method} | null, methods: {...} }
*/
(function () {
  'use strict';
  var cache = null, pending = null;
  function url() { var el = document.querySelector('[data-cx-rates-url]'); return el ? el.getAttribute('data-cx-rates-url') : null; }
  function load() {
    if (cache) return Promise.resolve(cache);
    if (pending) return pending;
    var u = url();
    if (!u) return Promise.resolve(null);
    pending = fetch(u, { credentials: 'omit' }).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) { cache = j; return j; }).catch(function () { return null; });
    return pending;
  }
  function profileFor(db, productId) {
    var pid = Number(productId), found = null, def = null;
    (db.profiles || []).forEach(function (p) { if (p.default) def = p; if (!found && p.items && p.items.indexOf(pid) >= 0) found = p; });
    return found || def;
  }
  function zoneFor(profile, country) {
    return (profile.zones || []).filter(function (z) { return z.c.indexOf(country) >= 0; })[0] || null;
  }
  function applicable(methods, price) {
    return methods.filter(function (m) {
      if (price == null) return true;
      if (m.min != null && price < m.min) return false;
      if (m.max != null && price > m.max) return false;
      return true;
    });
  }
  function hasAll(m, kinds) { return kinds.every(function (k) { return m.k.indexOf(k) >= 0; }); }
  function kindsEq(m, kinds) { return m.k.length === kinds.length && hasAll(m, kinds); }
  function compute(db, productId, price, country) {
    if (!db) return null;
    var profile = profileFor(db, productId);
    if (!profile || profile.plain) return null;
    var zone = zoneFor(profile, country);
    if (!zone) return null;
    var ms = applicable(zone.m, price);
    if (!ms.length) return null;
    // Basis = günstigste Versandart ohne Altmöbelmitnahme; bei gleichem Preis die mit mehr Leistung (Wohnung, Aufbau)
    var noAlt = ms.filter(function (m) { return m.k.indexOf('altmoebel') < 0; });
    if (!noAlt.length) noAlt = ms;
    noAlt.sort(function (a, b) { return a.p - b.p || b.k.length - a.k.length; });
    var base = noAlt[0];
    var included = base.k.slice();
    var opts = [], combo = null;
    function find(kinds) { var hit = ms.filter(function (m) { return kindsEq(m, kinds); })[0]; return hit || null; }
    var wantW = included.indexOf('wohnung') >= 0 ? ['wohnung'] : [];
    if (included.indexOf('montage') < 0) {
      var mM = find(wantW.concat(['montage']));
      if (mM) opts.push({ key: 'montage', price: mM.p - base.p, method: mM.n });
    }
    var mA = find(wantW.concat(included.indexOf('montage') >= 0 ? ['montage', 'altmoebel'] : ['altmoebel']));
    if (mA) opts.push({ key: 'altmoebel', price: mA.p - base.p, method: mA.n });
    var mB = find(wantW.concat(['montage', 'altmoebel']));
    if (mB && included.indexOf('montage') < 0) combo = { price: mB.p - base.p, method: mB.n };
    // Altmöbelmitnahme gibt es manchmal nur zusammen mit Montage (Sofas): dann als Option „Altmöbelmitnahme (inkl. Montage)“
    if (!mA && mB && included.indexOf('montage') < 0) opts.push({ key: 'altmoebel', price: mB.p - base.p, method: mB.n, withMontage: true });
    return { profile: profile.name, base: { included: included, price: base.p, method: base.n }, options: opts, combo: combo };
  }
  function label(key) { return key === 'montage' ? 'Montage durch die Spedition' : 'Altmöbelmitnahme'; }
  function baseLabel(included, price) {
    var w = included.indexOf('wohnung') >= 0, m = included.indexOf('montage') >= 0;
    if (w && m) return 'Lieferung bis in die Wohnung + Aufbau';
    if (w) return 'Lieferung bis in die Wohnung';
    return price ? 'Lieferung (frei Bordsteinkante)' : 'Kostenlose Lieferung (frei Bordsteinkante)';
  }
  function fmt(n) { return (n % 1 ? n.toFixed(2).replace('.', ',') : String(n)) + ' €'; }
  window.LB24Services = { load: load, compute: compute, label: label, baseLabel: baseLabel, fmt: fmt };
})();
